///ts:ref=Browser
/// <reference path="../browser/Browser.ts"/> ///ts:ref:generated
class PlatformDescriber {
	private static _info:PlatformDescriber;
	public static getInfo():PlatformDescriber {
		//d381fdbe-4f45-4314-b3a7-0751809f14b1
		if (!this._info) {
			this._info = new PlatformDescriber();
		}
		return this._info;
	}
	constructor() {
		PandaConsole.here;
		try {
			this.runGuid = Guid.generate();
			this.srcRevision = BuildProperties.srcRevision;
			this.buildDate = parseInt(BuildProperties.buildDate);
			this.locationHref = window.location.href;

			this.browserInfo = Browser.getInfo();
			this.project = 'UnknownProject';
			this.userId = 'UnknownUsertId';
			this.sns = 'UnknownSns';
			this.username = 'UnknownUserName';
			this.webGLInfo = WebGLDescriber.getInfo();
		} catch(e) {
			PandaConsole.errorUncritical(e);
		}
	}

	public browserInfo:UserAgentParser.ParseResult;
	public buildDate:number;
	public runGuid:string;
	public srcRevision:string;
	public locationHref:string;
	public project:string;
	public userId:string;
	public sns:string;
	public username:string;
	public webGLInfo:WebGLDescriber;

	public getScreenWidth():number {
		if (BrowserSpecific.scrrenSizeSupported()) {
			return window.screen.width;
		} else {
			return 0;
		}
	}

	public getScreenHeight():number {
		if (BrowserSpecific.scrrenSizeSupported()) {
			return window.screen.height;
		} else {
			return 0;
		}
	}

	public getScreenAvailableWidth():number {
		return window.innerWidth;
		//return document.documentElement.clientWidth;
	}

	public getScreenAvailableHeight():number {
		return window.innerHeight;
		//return document.documentElement.clientHeight;
	}
	

	public toString():string {
		return JSON.stringify(this, (key:string, value:any)=>{if (key !== '_productHash' && key !== 'comments' && key !=='products') {return value}}, 4);
	}
}